"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
var react_apollo_1 = require("react-apollo");
var lodash_1 = require("lodash");
exports.QUERY = graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\nquery SelectableCreditCardListQuery {\n  me {\n    creditCards {\n      id\n      last4\n      cardType\n      expirationYear\n      expirationMonth\n      cardholderName\n      needsReverification\n      primaryForCheckout\n      isSelected @client\n    }\n  }\n}"], ["\nquery SelectableCreditCardListQuery {\n  me {\n    creditCards {\n      id\n      last4\n      cardType\n      expirationYear\n      expirationMonth\n      cardholderName\n      needsReverification\n      primaryForCheckout\n      isSelected @client\n    }\n  }\n}"])));
exports.connectCheckoutButtonQuery = react_apollo_1.graphql(exports.QUERY, {
    skip: function (ownProps) { return !!lodash_1.get(ownProps.user, 'loggedOut', true); },
});
exports.connectSelectableCreditCardListQuery = react_apollo_1.graphql(exports.QUERY);
var templateObject_1;
//# sourceMappingURL=selectable_credit_card_list_query.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/selectable_credit_card_list_query.js
// module id = PQA/
// module chunks = 20 21 22